import { reaction } from "mobx"
import { observer } from "mobx-react-lite"
import { useEffect } from "react"

import { GlobalLoaderModel } from "@/components/Loader/GlobalLoaderModel.ts"
import { Loader } from "@/components/Loader/Loader.tsx"
import { useModel } from "@/hooks/useModel.ts"
import { useRootContext } from "@/hooks/useRootContext.ts"

export const GlobalLoader = observer(() => {
  const context = useRootContext()
  const model = useModel(() => new GlobalLoaderModel())

  // Some scheduling tricks to avoid the "Cannot update a component while rendering a different component" error
  useEffect(() => {
    return reaction(
      () => context.isLoading.get(),
      isLoading => model.setLoading(isLoading),
      { scheduler: fn => queueMicrotask(fn), fireImmediately: true }
    )
  }, [context, model])

  const visible = model.visible.get()
  return <Loader global visible={visible} />
})
